import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import Currency from '../../components/Currency';
import { DEFAULT_CURRENCY } from '../../config';
import CloseIcon from '../../icons/Close';

export const getPaymentDetails = (
  total,
  selectedToPay,
  t,
) => [
  {
    label: t('recurrPayment.amount.toPay'),
    value: (
      <Grid container justifyContent="flex-end">
        <Currency
          value={selectedToPay}
          currency={DEFAULT_CURRENCY}
          withSymbol
        />
      </Grid>
    ),
  },
  {
    label: t('recurrPayment.amount.remainder'),
    value: (
      <Grid container justifyContent="flex-end">
        <Currency
          value={total - selectedToPay}
          currency={DEFAULT_CURRENCY}
          withSymbol
        />
      </Grid>
    ),
  },
];

export const getBasketDetails = (
  basket,
  selectedContract,
  handleRowClick,
  handleCloseIconClick,
) => {
  const basketRows = basket.map((item) => {
    const { policyNumber, totalAndBalance } = item;
    const isSelected = selectedContract && (selectedContract.policyNumber === policyNumber);

    return {
      hasInteractiveLabel: true,
      label: (
        <Typography
          style={{ cursor: 'pointer', color: isSelected ? '#2c2738' : '' }}
          onClick={() => handleRowClick(item)}
        >
          {policyNumber}
        </Typography>
      ),
      value: (
        <Grid container spacing={1} justifyContent="flex-end" alignItems="center">
          <Grid item>
            <Currency value={totalAndBalance && totalAndBalance.selectedToPay} withSymbol />
          </Grid>
          <Grid item>
            <Typography
              style={{ cursor: 'pointer' }}
              onClick={(e) => {
                e.stopPropagation();
                handleCloseIconClick(policyNumber);
              }}
            >
              <CloseIcon />
            </Typography>
          </Grid>
        </Grid>
      ),
    };
  });

  return basketRows;
};

export default getPaymentDetails;
